module.exports = __webpack_public_path__ + "img/merchant.279f0030.png";